import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ROUTES = {
  owner: "/admin", hr: "/admin", supervisor: "/admin",
  kasir: "/pos", crew: "/karyawan", gudang: "/admin",
  logistik: "/admin", host_live: "/karyawan", karyawan: "/karyawan",
  pelanggan: "/store",
  pengawas_produksi: "/produksi", cutting: "/produksi", mandor: "/produksi",
  penjahit: "/produksi", finishing_qc: "/produksi",
};

export default function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-kiyana-canvas">
        <Loader2 className="w-8 h-8 animate-spin text-kiyana-maroon" />
      </div>
    );
  }
  if (!user) return <Navigate to="/store" replace />;
  return <Navigate to={ROUTES[user.role] || "/store"} replace />;
}

export function Protected({ children, allow, redirect = "/login" }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-kiyana-canvas">
        <Loader2 className="w-8 h-8 animate-spin text-kiyana-maroon" />
      </div>
    );
  }
  if (!user) return <Navigate to={redirect} replace />;
  if (allow && !allow.includes(user.role) && user.role !== "owner") {
    return <Navigate to={ROUTES[user.role] || "/store"} replace />;
  }
  return children;
}
